export const globalErrorsProps = {
  basename: "/erro",
};
